export const getStatusColor = (status) => {
  const colors = {
    ABERTO: "bg-green-100 text-green-800",
    ATENDIMENTO: "bg-yellow-100 text-yellow-800",
    AGUARDANDO: "bg-blue-100 text-blue-800",
    RESOLVIDO: "bg-indigo-100 text-indigo-800",
    FECHADO: "bg-red-100 text-red-800",
    ARQUIVADO: "bg-amber-100 text-amber-800",
    INDEFINIDO: "bg-gray-100 text-gray-800",
  };
  return colors[status] || "bg-gray-100 text-gray-800";
};

export const scheduledMessageStatusConfig = {
  PENDING: {
    label: "Pendente",
    badge:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300",
  },
  SENT: {
    label: "Enviada",
    badge:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300",
  },
  FAILED: {
    label: "Falhou",
    badge: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300",
  },
  CANCELED: {
    label: "Cancelada",
    badge: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400",
  },
};

export const getPriorityColor = (priority) => {
  const colors = {
    alta: "bg-red-500",
    media: "bg-yellow-500",
    baixa: "bg-green-500",
  };
  return colors[priority] || "bg-gray-500";
};

export const getDayLabel = (dateString) => {
  if (!dateString) return "Sem data";

  const date = new Date(dateString);
  const today = new Date();

  const startOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );

  const startOfDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );

  const diffDays = (startOfToday - startOfDate) / (1000 * 60 * 60 * 24);

  if (diffDays === 0) return "Hoje";
  if (diffDays === 1) return "Ontem";

  return date.toLocaleDateString("pt-BR");
};

export const getFileUrl = (path) => {
  return process.env.REACT_APP_URL + path;
};

export const getFileType = (path) => {
  const ext = path.split(".").pop().toLowerCase();

  if (["jpg", "jpeg", "png", "gif", "ico", "webp"].includes(ext))
    return "image";
  if (["mp4", "webm", "ogg"].includes(ext)) return "video";
  if (["mp3", "wav", "ogg"].includes(ext)) return "audio";
  if (["pdf", "doc", "docx", "txt", "xls", "xlsx", "ppt", "pptx"].includes(ext))
    return "doc";

  return "other";
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined) return "—";
  if (seconds < 60) return `${Math.round(seconds)} s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)} min`;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.round((seconds % 3600) / 60);
  return minutes ? `${hours}h ${minutes}min` : `${hours}h`;
};

export const formatDate = (date) => {
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(date));
};

export const formatTime = (time) => {
  return new Intl.DateTimeFormat("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(time));
};

// Cursor da primeira página de conversas: meia-noite de amanhã, para incluir
// tudo de hoje.
export const tomorrowCursor = () => {
  const cursor = new Date();
  cursor.setHours(0, 0, 0, 0);
  cursor.setDate(cursor.getDate() + 1);
  return cursor;
};
